import { ROUTES } from "./routes";

export const AppConfig = {
	PATH: process.env.REACT_APP_PATH_URL
}

// Auth0 API Configuration
export const Auth0Config = {
	appUrl: process.env.REACT_APP_PATH_URL,
    domain: process.env.REACT_APP_AUTH0_DOMAIN,
    audience: process.env.REACT_APP_AUTH0_AUDIENCE,
	clientId: process.env.REACT_APP_AUTH0_CLIENT_ID,
	callbackAuthenticateUrl: process.env.REACT_APP_PATH_URL + ROUTES.AUTHENTICATE,
}

export const ApiConfig = {
	url: process.env.REACT_APP_API_PATH
}

export const CHARGEBEE = {
	site: process.env.REACT_APP_CHARGEBEE_SITE,
	defaultPlanId: process.env.REACT_APP_CHARGEBEE_DEFAULT_PLAN_ID,
}


// WEBPACK FOOTER //
// ./src/config/config.ts